var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInputCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(12.469670, 10.530330) rotate(-45.000000) translate(-12.469670, -10.530330) ",
  x: 5.35570888,
  y: 9.03033009,
  width: 14.2279221,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(6.780330, 12.780330) rotate(-315.000000) translate(-6.780330, -12.780330) ",
  x: 2.84834957,
  y: 11.2803301,
  width: 7.86396103,
  height: 3,
  rx: 1
})))));
export default SvgInputCheckmark;